import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ContactUs from '../../components/ContactUs/ContactUs';
import PageTemplate from '../../components/PageTemplate/PageTemplate';

export default function ContactUsPage() {
  const { t } = useTranslation();
  return <PageTemplate title={t('contact_us.title')} content={<ContactUs />} />;
}
